import styled from "styled-components";

export const TableStyle = styled.div`
  /* heaaders */
  .css-1ygcj2i-MuiTableCell-root {
    font-size: 1em;
    font-weight: 600;
    font-size: 10px;
    line-height: 16px;
    /* identical to box height, or 160% */

    /* display: flex;
        align-items: center; */
    letter-spacing: 0.06em;
    text-transform: uppercase;

    /* Table/Head/Text */

    color: #8492a6;
  }
  .css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root {
    white-space: pre;
  }

  /* body */
  .css-177gid-MuiTableCell-root {
    text-align: left;
  }

  .css-11w94w9-MuiTableCell-root {
    padding: 16px;
  }

  /* Content of table from map */
  h6 {
    font-weight: 600;
    font-size: 14px;
    line-height: 23px;
    display: flex;
    align-items: center;
    font-feature-settings: salt on;
    color: #27272e;
    white-space: pre;
  }

  .sub {
    font-weight: normal;
    font-size: 13px;
    line-height: 150%;
    /* identical to box height, or 19px */

    display: flex;
    align-items: center;

    color: #272833;

    opacity: 0.7;
  }

  .body {
    font-weight: normal;
    font-size: 14px;
    line-height: 23px;
    /* identical to box height, or 164% */

    display: flex;
    align-items: center;
    font-feature-settings: salt on;
    color: #27272e;
  }

  .menu {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &:hover {
      background: #e1e8ff;
    }
  }

  /* Pagination */
  .css-pdct74-MuiTablePagination-selectLabel,
  .css-194a1fa-MuiSelect-select-MuiInputBase-input,
  .css-levciy-MuiTablePagination-displayedRows {
    font-size: 12px;
  }
  .status {
    border: 1px solid #8cdfb3;
    box-sizing: border-box;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 6px 8px;

    p {
      font-weight: 600;
      font-size: 12px;
      line-height: 150%;
      /* identical to box height, or 18px */

      display: flex;
      align-items: center;
      text-transform: uppercase;

      color: #4aae8c;
    }

    &.incomplete {
      border-color: #f68e87;

      p {
        color: #cf4655;
      }
    }

    &.pending {
      border-color: #f7936f;

      p {
        color: #f7936f;
      }
    }

    &.completed {
      border-color: #4c6fff;

      p {
        color: #4c6fff;
      }
    }
  }

  .facilityStatus {
    border-radius: 0.2rem;
    padding: 0.6rem 0.8rem;
    border: 0.1rem solid;
    font-weight: 600;
    font-size: 1.2rem;
    text-transform: uppercase;
    text-align: center;

    &.unapproved {
      /* border-color: #f68e87; */
      color: #cf4655;
    }

    &.pending {
      color: #f7936f;
    }

    &.completed {
      color: #4c6fff;
    }

    &.approved {
      color: #8cdfb3;
    }
  }
`;

export const ModalContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 540px;
  max-width: 95%;
  background: #ffffff;
  /* Shadow/shadow-sm */

  box-shadow: 0px 0px 1px rgba(12, 26, 75, 0.2),
    0px 1px 3px rgba(50, 50, 71, 0.1);
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  &.big {
    img {
      width: 80%;
    }
  }

  .referral-link {
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #4c6fff;
    width: 100%;
    max-width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    word-break: break-word;
    margin-top: 24px;
    padding: 16px;
    filter: drop-shadow(0px 1px 2px rgba(50, 50, 71, 0.08))
      drop-shadow(0px 0px 1px rgba(50, 50, 71, 0.2));
    background: #ffffff;
    border-radius: 8px;
  }

  .input-grp {
    margin-bottom: 8px;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    display: block;
    align-items: center;
    color: #425466;

    margin-bottom: 32px;
    width: 100%;

    &.w48 {
      width: 48%;
    }
  }

  form {
    .card-element-input {
      width: 100%;
      font-size: 15px;
      line-height: 15px;
      background: white;
      margin-top: 8px;
      font-weight: 400;
      color: #222;
      padding: 16px;

      box-shadow: 0px 1px 2px rgba(50, 50, 71, 0.08),
        0px 0px 1px rgba(50, 50, 71, 0.2);
      border-radius: 6px;
      outline: none;

      transition: 1s ease;

      ::placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #7a828a;
        opacity: 1; /* Firefox */
        font-weight: 500;
      }

      :-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #7a828a;
        font-weight: 500;
      }

      ::-ms-input-placeholder {
        /* Microsoft Edge */
        color: #7a828a;
        font-weight: 500;
      }

      &:focus {
        box-shadow: 0px 0px 0px 2px rgba(76, 111, 255, 0.3);
        border: 1px solid #7895ff;
      }
      &:disabled {
        background: #edf2f7 !important;
      }
    }
  }
  button {
    width: 100%;
  }

  .btn-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
    width: 100%;

    button {
      font-weight: 600;
      font-size: 14px;
      line-height: 14px;
      color: #4c6fff;
      width: 48%;
      background: #e1e8ff;
      border-radius: 8px;
      white-space: pre;
      padding: 16px 24px;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        margin-right: 10px;
      }
    }

    @media (max-width: 320px) {
      flex-direction: column;

      button {
        width: 100%;

        &:first-child {
          margin-bottom: 10px;
        }
      }
    }
  }
  .modal {
    &-label {
      font-weight: 600;
      font-size: 14px;
      line-height: 24px;
      color: #718096;
      width: 100%;
      text-align: left;
      margin-bottom: 2.125em;
    }

    &-illustration {
      height: 7.75em;
    }

    &-header {
      font-weight: 600;
      font-size: 16px;
      line-height: 136.02%;

      text-align: center;

      color: #000000;
      margin-top: 2.125em;

      &__big {
        font-weight: 600;
        font-size: 20px;
        line-height: 136.02%;
        text-align: center;
        color: #27272e;
        margin-top: 32px;

        @media (max-width: 560px) {
          font-size: 18px;
          margin-top: 24px;
        }
      }
    }

    &-body {
      font-weight: 400;
      font-size: 14px;
      line-height: 162%;
      text-align: center;
      font-feature-settings: "salt" on;
      color: #425466;
      margin-top: 10px;
    }

    &-cta-main {
      margin-top: 1.5em;
    }
    &-cta-secondary {
      margin-top: 1em;
      font-size: 14px !important;
      color: var(--blue);
    }
  }

  h3 {
  }
  .btn-flex {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    margin-bottom: -16px;

    button {
      /* padding: 12px 20px; */
      color: var(--primary);
      /* border: 1px solid var(--primary); */
      border-radius: 6px;
      font-size: 1.2rem;
      font-weight: 600;
      line-height: 12px;
      width: auto;
    }
  }

  .detail-flex {
    display: flex;
    align-items: center;
    margin-top: 0.8em;
    justify-content: flex-start;
    width: 100%;

    b {
      font-weight: 600;
      font-size: 14px;
      line-height: 24px;
      color: #718096;
      text-align: left;
      margin-right: 4px;
    }
    p {
      font-weight: 600;
      font-size: 14px;
      line-height: 136.02%;
      text-align: center;
      color: #121212;
    }
  }

  .upload-form {
    width: 100%;
    margin: 1em 0;
  }

  .upload-button {
    background-color: #f5f6f4;
    border: 1px solid #e4e6e6 !important;
    display: flex;
    align-items: center;
    padding: 16px;
    border-radius: 8px;
    color: #777777;
    font-size: 15px;
    font-weight: 500;
    margin-top: 8px;

    svg {
      height: 24px;
      width: 24px;
      margin-right: 10px;
    }
  }

  input[type="file"] {
    display: none;
  }

  .upload-result {
    margin-top: 12px;

    .progress-value {
      margin-bottom: 0;
    }

    span {
      display: inline-block;
      vertical-align: top;
      font-weight: 600;
      font-size: 16px;
      line-height: 25px;
      display: flex;
      align-items: center;
      color: #425466;
      margin-bottom: 0.6em;
    }

    .flex {
      justify-content: space-between;
      margin-top: 0.6em;
      align-items: center;

      .file-remove {
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      svg {
        height: 24px;
        width: 24px;
      }
    }
  }
`;
